import React from "react"
import { Box, Paper, Tooltip, Typography } from "@mui/material";
import StarIcon from '@mui/icons-material/Star';
import { DimensionsReducer } from "../../state/reducers/app";

export type TopListItem = {
  name: string,
  countNumber: number,
  additionalCountNumber?: number
}

type TopListComponentProps = {
  items: Array<TopListItem>,
  dimensions?: DimensionsReducer,
  title: string,
  starIcon?: boolean,
  container?: boolean,
  ascending?: boolean,
  max?: number
}

export default function TopListComponent({ items, dimensions, title, starIcon, container, ascending, max }: TopListComponentProps
): React.ReactElement {


  const isTablet = dimensions?.device === 'tablet'
  const sortedItems = [...items]
    .sort((a, b) => {
      return ascending ? a.countNumber - b.countNumber : b.countNumber - a.countNumber
    })
    .slice(0, 10);

  const getMax = () => {
    return Math.max(...sortedItems.map(item => item.countNumber))
  }

  const renderContent = () => (
    <>
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          gap: 5,
          paddingBottom: 5
        }}>
        <Typography sx={{ fontFamily: 'VogieBold' }} variant="h5">
          {title}
        </Typography>
        {starIcon && (
          <StarIcon style={{ color: "#F2BD41" }} />
        )}
      </div>

      <div
        style={{
          display: "flex",
          gap: isTablet ? 6 : 2,
          flexDirection: "column"
        }}>
        {sortedItems.map((item, idx) => (
          <DisplayItem
            key={idx}
            name={item.name}
            countNumber={item.countNumber}
            additionalCountNumber={item.additionalCountNumber}
            rank={idx + 1}
            max={max ?? getMax()}
            isTablet={isTablet}
          />
        ))}
      </div>
    </>
  );

  const containerStyles = container ? {
    width: "100%",
    padding: "16px 32px",
    boxShadow: '0 2px 6px 1px rgba(222,222,222,0.50)',
    borderRadius: '20px',
    display: 'flex',
    justifyContent: 'space-between',
    flexDirection: "column",
    gap: 2,
  } : {
    width: "100%",
    padding: "0px 30px",
  };

  return container ? (
    <Paper sx={containerStyles}>
      {renderContent()}
    </Paper>
  ) : (
    <Box sx={containerStyles}>
      {renderContent()}
    </Box>
  );
}

const DisplayItem = ({
  name,
  rank,
  max,
  isTablet,
  countNumber,
  additionalCountNumber
}: {
  name?: string;
  rank: number;
  max: number;
  isTablet: boolean;
  countNumber: number;
  additionalCountNumber?: number
}) => {
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        gap: 14,
        width: "100%",
        flexDirection: "row",
      }}
    >
      <div
        style={{
          minWidth: isTablet ? 200 : 240,
          display: "flex",
          alignItems: "center",
          gap: 8,
          overflow: "hidden",

        }}
      >
        <Typography
          style={{
            fontSize: 14,
            minWidth: 18,
            textAlign: "right"
          }}>{rank}.
        </Typography>
        <Typography
          style={{
            fontSize: 14,
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            maxWidth: 210,
          }}
        >
          {name}
        </Typography>
      </div>
      <div
        style={{
          flex: 1,
          display: "flex",
          alignItems: "center",
          position: "relative",
        }}
      >
        {!isTablet && (
          <>
            <div style={{ flex: 1 }}>
              <div
                style={{
                  width: "100%",
                  height: 7,
                  backgroundColor: "transparent",
                  position: "relative",
                }}
              >
                <div
                  style={{
                    width: `${(countNumber / max) * 100}%`,
                    height: "100%",
                    backgroundColor: "#7EB48A",
                    position: "relative",
                  }}
                />
                <div
                  style={{
                    position: "absolute",
                    left: `${(countNumber / max) * 100}%`,
                    top: "50%",
                    transform: "translateY(-45%) translateX(6px)",
                    whiteSpace: "nowrap",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center"
                  }}
                >
                  <Tooltip title="Total treatments">
                    <Typography style={{ fontSize: 12, color: "#808080" }}>
                      {countNumber}
                    </Typography>
                  </Tooltip>
                  {additionalCountNumber !== undefined && (
                    <>
                      <Typography style={{ fontSize: 12, color: "#B0B0B0", margin: "0 6px" }}>
                        |
                      </Typography>
                      <Tooltip title="Average treatments">
                        <Typography style={{ fontSize: 12, color: "#808080" }}>
                          {additionalCountNumber}
                        </Typography>
                      </Tooltip>
                      <Typography style={{ fontSize: 12, color: "#808080", marginLeft: 4 }}>
                        avg
                      </Typography>
                    </>
                  )}
                </div>
              </div>
            </div>
          </>
        )}

        {isTablet && (
          <Typography style={{ fontSize: 12, color: "#808080", marginLeft: 8 }}>
            ({countNumber})
          </Typography>
        )}
      </div>

      <div>

      </div>
    </div>
  );
};

